export const fdmIrsCalls = ({ child }) => {
  child.call('globalStyles', {
    id: 'connect-wrapper-adjust',
    styles:
      'div.connectWrapper{height: auto;} #GlobalFooter{padding-top: 7px;}',
  });

  child.call('globalStyles', {
    styles:
      '#GlobalHeader{display:none;} div.max-height.master-container{height: 100%}; .service-toolbar-buttons{display: none;} #frmGenericObject{overflow:hidden;}html, body {max-height: calc(100% - 1px);} .variable-flex-content.card{margin-bottom: 0px;} .saveFooterContainer{padding-top: 20px;}',
    id: 'dm-globalstyles',
  });

  child.call('globalStyles', {
    styles: `.transmittals-header{margin: 0 20px; padding: 7px 0;} .btn-toolbar.vertical-top-margin .btn.btn-lg.btn-wide-lg.btn-secondary, .btn-toolbar.vertical-top-margin .btn.btn-lg.btn-wide-lg.btn-primary.disabled{display: none;}`,
    id: 'dm-transmittal-formatting',
  });
};
